import type { PipelineStepState } from '../../types';

export function formatReceivedAt(timestamp: number): string {
  return new Date(timestamp).toLocaleTimeString(undefined, {
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    fractionalSecondDigits: 3,
  });
}

export function previewOutput(output: unknown, error?: string): string {
  if (error) {
    return error;
  }

  if (output === null || output === undefined) {
    return '—';
  }

  const serialized = JSON.stringify(output);
  return serialized.length > 140 ? `${serialized.slice(0, 140)}…` : serialized;
}

export function resolveStreamProgressStatus(
  step: PipelineStepState,
  isRunning: boolean,
  completedCount: number,
): 'active' | 'exception' | 'success' | 'normal' {
  if (isRunning) {
    return 'active';
  }

  if (step.status === 'error') {
    return 'exception';
  }

  if (step.streamMode === 'summary') {
    return 'normal';
  }

  return completedCount > 0 ? 'success' : 'normal';
}
